import React, {useCallback, useEffect, useRef, useState} from 'react';
import debounce from 'lodash/debounce';
import {Create, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, useDataProvider} from 'react-admin';
import {useFormContext, useWatch} from 'react-hook-form';

import DuplicateList from '../../components/Moderation/DuplicateList';
import {EModerationStatus, ITool, moderationStatuses} from '../../models';
import {styledInput, styledSelect} from '../../styles';

export const ToolCreate = (props: any) => {
    const [isValid, setIsValid] = useState(false);

    return (
        <Create {...props} redirect="list">
            <SimpleForm
                defaultValues={{moderationStatus: EModerationStatus.NEW}}
                toolbar={<ToolCreateToolbar disabled={!isValid}/>}
            >
                <ToolCreateForm onValid={setIsValid}/>

            </SimpleForm>
        </Create>
    );
};

const ToolCreateForm = ({onValid}: any) => {
    const [duplicates, setDuplicates] = useState<ITool[] | null>(null);
    const dataProvider = useDataProvider();
    const searchRef = useRef('');

    const {
        control,
    } = useFormContext();

    const {name} = useWatch({control});
    const isExist = name && duplicates ? !!duplicates.find(it => it.name.toLowerCase() === name.toLowerCase()) : false;

    searchRef.current = name;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const search = useCallback(debounce(async () => {
        if (!searchRef.current || searchRef.current.length < 3) return;

        const response = await dataProvider.get(`admin/meta/tools?q=${searchRef.current}`, {area: ''});
        const isExist = !!response.data.content?.find((it: ITool) => it.name.toLowerCase() === searchRef.current.toLowerCase());

        // already exists
        if (response.data.content.length) {
            setDuplicates(response.data.content);
        }

        onValid(!isExist);
    }, 1000), []);

    useEffect(() => {
        setDuplicates(null);

        if (!name) return;

        onValid(false);
        search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name]);

    return (
        <>
            <TextInput source="name" sx={styledInput} validate={required()}/>
            <SelectInput
                choices={moderationStatuses}
                optionValue="name"
                source="moderationStatus"
                sx={styledSelect}
                validate={required()}
            />

            {duplicates && (
                <DuplicateList error={isExist} items={duplicates}/>
            )}

        </>
    );
};

const ToolCreateToolbar = ({disabled}: {disabled: boolean}) => {
    return (
        <Toolbar>
            <SaveButton
                disabled={disabled}
                label="Save"
            />
        </Toolbar>
    );
};
